import Vue from 'vue'
import 'sweetalert2'

const swal = require('sweetalert2') 

Vue.prototype.$swal = swal
